import { FC } from 'react';
import { Helmet } from 'react-helmet-async';

export const Head: FC<{ title: string }> = ({ title }) => {
  return <Helmet defaultTitle={process.env.REACT_APP_GENERAL_PRODUCT_NAME} title={title} />;
};
